module.exports = __webpack_public_path__ + "img/zykf.a11eb6d8.png";